import { FormGroup } from '@angular/forms'
import { IServiceOrder } from '../interface'

export interface IPricing {
  min: number
  price: number
}

export interface IPackage {
  description: string
  name: string
  pricing: IPricing[]
  rank: number
}

export interface IServiceProvider {
  image: any
  email?: string
  districts: string[]
  id?: string
  name: string
  contact_numbers: any
  packages: IPackage[]
}

export interface IService {
  id?: string
  description: string
  name: string
  service_providers: IServiceProvider[]
  status: string
  time: string
  type: string
  unit: string
  unitPlural: string
  country?: string
  image?: string
}

export interface IServiceState {
  currentProviderId: string
  serviceList: IServiceList[]
  loaders: ILoaders
  services: IService[]
  errors: Partial<ILoaders>
  success: Partial<ILoaders>
  currentServiceId: string | null
  serviceProviderFilter: string
  serviceProviderPricing: { [x: string]: { [x: string]: IDistrictPricing } }
}

export interface ServiceOrderState {
  serviceOrders: IServiceOrderState
  loaders: Partial<ILoaders>
  errors: Partial<ILoaders>
  success: Partial<ILoaders>
  // currentServiceId: string | null
  serviceProviderPricing: { [x: string]: { [x: string]: IDistrictPricing } }
}

export interface IServiceList {
  label: string
  value: string
}
export interface IServiceOrderState {
  sortType: SortType
  limit?: number
  page?: number
  total: number
  data?: IServiceOrder[]
  filters: IOrderFilter
  selectedOrder?: IServiceOrder
  selectedOrderId?: string
  isLoading: boolean
}
export interface IOrderFilter {
  farmer_name: string
  service_name: string
  status: string
  dateRange: any[]
}

export interface ILoaders {
  singleOrder: boolean
  singleSoilTestOrder: boolean
  createOrder: boolean
  serviceUpdate: boolean
  serviceProviderCreate: boolean
  serviceProviderDelete: boolean
  getServices: boolean
  serviceDelete: boolean
  serviceProviderPricing: boolean
  serviceProviderPricingUpdate: boolean
  serviceProviderPricingDuplicate: boolean
  uploadingResults?: boolean
}

export type FormModel<T> = { [P in keyof T]: [T[P], any?] | FormGroup }

export interface ServiceResponse {
  data: IService
  success: boolean
}
export interface IDistrictPricing {
  type: string
  service_provider_id: string
  district: string
  packages: IPackage[]
}

export enum sortDirection {
  ASC = 1,
  DESC = -1,
}

export enum fieldTypes {
  DATE = 'date',
  STRING = 'string',
  NUMBER = 'number',
}
export interface SortType {
  field: string
  sort: sortDirection
  fieldType?: fieldTypes
  label: string
}
